module.exports = __webpack_public_path__ + "static/media/logo.539fc884.png";